import React, { useState, useEffect } from "react";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";

import Modal from "../../utils/customModal";
import * as ProviderActions from "../../../Redux/actions/providerActions";
import useApi from "../../hooks/useApi";
import {
  errorContainer,
  getNumberApprovals,
  loadingHtml,
  sucessInfoModal,
} from "../../utils/functions";
import { getSessionInfo } from "../../../Redux/reducer/session";
import { renderItems, formatData } from "./utils";
import { useTranslation } from "react-i18next";
import TokenComponent from "../token";
import { getModules } from "../../../Redux/reducer/clients";
import { MOD_PROVID } from "../../../permissions";

const defaultModal = { show: false, content: null };
const defaultToken = {
  show: false,
  code: null,
  approve: null,
};

const ProviderTemporal = ({
  companyId,
  providerId,
  currency,
  closeInfo,
  invitation = false,
}) => {
  const [state, setState] = useState({
    institution: {},
  });
  const [modal, setModal] = useState(defaultModal);
  const [token, setToken] = useState(defaultToken);

  const dispatch = useDispatch();
  const { userType, clientModules } = useSelector((state) => ({
    userType: getSessionInfo(state).userType,
    clientModules: getModules(state),
  }));
  const { getApiCAll, putApiCAll } = useApi();
  const { t } = useTranslation();

  const isCSA = userType === "CSA";

  const {
    titles: { titleA, titleB },
    buttonText,
  } = {
    titles: t("admissions.providers", {
      returnObjects: true,
    }),
    buttonText: t("general.buttons", { returnObjects: true }),
  };

  useEffect(() => {
    const getInitialData = async () => {
      const { getProviderAdmissions, getProviderById } = ProviderActions;

      const action = !isCSA ? getProviderAdmissions : getProviderById;

      setLoadingModal();
      try {
        const institutionData = (
          await dispatch(action(providerId, companyId, currency))
        ).data;

        let banks = [];

        if (institutionData?.country?.code === "PA")
          banks = (await getApiCAll("/banks/bank-ach/PA")).data.data;

        setState({
          institution: formatData(institutionData, banks),
        });
      } catch (error) {
        console.log(error);
      }
      clearModal();
    };

    getInitialData();

    return () => setState({ institution: {} });
  }, []);

  useEffect(() => {
    if (token.code) handleSubmit(token.approve);
  }, [token.code]);

  const { institution } = state;

  const double = !!institution.recordTmps?.[0]?.data;

  const getValue = (name, main = true) => {
    return {
      value: main ? institution[name] : institution.recordTmps[0].data[name],
      updated:
        !main &&
        JSON.stringify(institution.recordTmps[0].data[name]) !==
          JSON.stringify(institution[name]),
    };
  };

  const setLoadingModal = () => {
    setModal({ show: true, content: loadingHtml() });
  };

  const clearModal = () => setModal(defaultModal);

  const clearToken = () => setToken(defaultToken);

  const goBack = () => setToken({ show: false, code: null, approve: null });

  const validate = ({ validToken = null }) => {
    if (validToken === null) {
      setToken({ show: true, code: token.code, approve: token.approve });
    } else {
      setToken({ show: false, code: validToken, approve: token.approve });
    }
  };

  const handleSubmit = async (approve) => {
    const approvals = getNumberApprovals(clientModules, MOD_PROVID);

    if (isCSA && !token.code && approvals >= 0) {
      return setToken({ show: true, code: null, approve });
    }

    const header = token.code ? { "x-security-code": token.code } : {};

    const url = `/providers${
      isCSA ? (invitation ? "/provider-invitation/" : "/me/") : "/"
    }approve-or-rejected`;

    const data = { companyId, providerId, approve, currency };
    setLoadingModal();

    try {
      const response = await putApiCAll(url, [data], header);

      const success = response.data?.data[0]?.success;
      const title = response.status === 200 ? "Admisión proveedores" : "Error";
      const description = success
        ? "La operación fue realizada con éxito"
        : response.data?.data[0]?.message ??
          t("admissions.successModal.message");
      const action = success ? () => closeInfo(true) : clearModal;

      const content = sucessInfoModal(title, description, {
        SelBtn: { text: "Continuar", action },
      });

      setModal({ show: true, content });
    } catch (err) {
      const notification = err?.response?.data?.notifications?.[0] || {};
      setModal({
        show: true,
        content: errorContainer(
          notification.message,
          notification.description,
          { cancelBtn: { text: buttonText.close, action: clearModal } }
        ),
      });
    }
    clearToken();
  };

  return (
    <>
      <div className="company-details">
        <div className="row col-12 pendingDetails">
          <div className={`${double ? "col-6" : "col-12"}`}>
            <p className="edit-profile-style">{titleA}</p>
            {renderItems(userType, getValue)}
          </div>
          {double && (
            <div
              className="col-6 gray-background"
              style={{ paddingBottom: 10 }}
            >
              <p className="edit-profile-style updated-info">{titleB}</p>
              {renderItems(userType, getValue, false)}
            </div>
          )}
          <div className="form-actions clearfix">
            <SecondaryButton className="accept" onClick={() => closeInfo()}>
              {buttonText.back}
            </SecondaryButton>

            <SecondaryButton
              className="accept"
              onClick={() => handleSubmit(false)}
            >
              {buttonText.rejected}
            </SecondaryButton>
            <PrimaryButton onClick={() => handleSubmit(true)}>
              {buttonText.approve}
            </PrimaryButton>
          </div>
        </div>
        <Modal show={modal.show}>{modal.content}</Modal>
      </div>
      {token.show && (
        <div className="col-6">
          <TokenComponent send={validate} goBack={goBack} />
        </div>
      )}
    </>
  );
};

export default ProviderTemporal;
